<template>
  <div class="container bg-white">
    <!-- <img src="../datav/img/dialog-bg.png" class="bg-img" alt="" /> -->
    <div class="content">
      <div>{{ title }}</div>
      <div style="width: 100%" class="mt-10">
        <el-input v-model="searchValue" placeholder="搜索小区">
          <div slot="suffix">
            <div
              class="flex justify-center items-center cursor-pointer"
              style="height: 42px; width: 50px"
            >
              <img
                @click="onSearch"
                style="width: 20px; height: 20px"
                src="../datav/img/search.png"
                alt=""
              />
            </div>
          </div>
        </el-input>
        <div class="list__container">
          <div
            v-for="(item, index) in filterList"
            :key="index"
            class="flex items-center item mt-5 pl-10 cursor-pointer"
            :class="selectItem.name == item.name ? 'active' : ''"
            @click="onCheckItem(item)"
          >
            <img
              src="../datav/img/house.png"
              alt=""
              style="height: 20px; width: 20px"
            />
            <div class="ml-4">{{ item.name }}</div>
          </div>
        </div>

        <div slot="footer">
          <div
            class="flex justify-center items-center cursor-pointer"
            style="width: 100%; margin-top: 50px; padding-bottom: 30px"
            @click="handleSubmit"
          >
            <el-button plain type="primary">确 定</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="visible = false">确 定</el-button>
    </span> -->
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      filterList: [],
      selectItem: {},
      searchValue: "",
    };
  },
  props: {
    list: [],
    value: "",
    title: {
      type: String,
      default: "大渡口区",
    },
  },
  watch: {
    value(n, o) {
      this.selectItem = {
        name: n,
      };
    },
    list: {
      handler(n) {
        this.onSearch();
      },
      deep: true,
    },
  },
  computed: {
    // list() {
    //   return this.globalData.communities.map((v) => {
    //     return {
    //       name: v,
    //     };
    //   });
    // },
    key: {
      get() {
        return this.value;
      },
      set(n) {
        this.$emit("update:value", n);
      },
    },
  },
  methods: {
    onSearch() {
      if (!this.searchValue) {
        this.filterList = this.list;
      }
      this.filterList = this.list.filter((v) =>
        v.name.includes(this.searchValue)
      );
    },
    onCheckItem(item) {
      this.selectItem = item;
    },

    handleSubmit() {
      // this.$store
      //   .dispatch("app/getGlobalData", { key: this.selectItem.name })
      //   .then((resp) => {});
      // this.visible = false;
      // ...mapMutations("/app"),
      this.key = this.selectItem.name;
      if (!this.selectItem.name) {
        this.$EditionEmptyDialog({
          show: true,
          content: "至少选择一项",
        });
        return;
      }
      this.$emit("submit", this.selectItem.name);
    },
  },
  mounted() {
    this.filterList = this.list;
  },
};
</script>
<style scoped lang="less">
.container {
  position: relative;
  .bg-img {
    position: absolute;
    height: 110%;
    width: 100%;
  }
  .content {
    position: relative;
    z-index: 2;
    color: #333;
    padding-top: 6%;
    padding-left: 30px;
    padding-right: 30px;
    font-weight: bold;
    font-size: 20px;
  }
  .list__container {
    margin-top: 30px;
    height: 370px;
    overflow: scroll;
    .item {
      width: 100%;
      height: 39px;
      // background: linear-gradient(
      //   90deg,
      //   #161f4e 0%,
      //   rgba(4, 24, 40, 0.28) 100%
      // );
      //   opacity: 0.28;

      font-size: 16px;
      color: #01b3e6;
      font-weight: 500;
    }
    .item:hover {
      color: #fff;
      background: linear-gradient(
        90deg,
        #2a3895 0%,
        rgba(4, 24, 40, 0.28) 100%
      );
    }
    .active {
      color: #fff;
      background: linear-gradient(
        90deg,
        #2a3895 0%,
        rgba(4, 24, 40, 0.28) 100%
      );
    }
  }
}
::v-deep {
  .el-dialog {
    // 取消阴影和背景色
    background: rgba(0, 0, 0, 0);

    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0);

    box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
  }
  .el-input__inner {
    height: 42px;
    border: 1px solid #077fd4;
    border-radius: 8px;
    background: none;
    color: #01b3e6;
  }
  .el-dialog__header {
    height: 20px;
    padding: 0;
  }
}
</style>
